import { checkUserStatusAndUpdateCensoredImagesRights } from "@modules/login-user/checkUserLoginStatus"
import { applyNotificationDots } from "./overall-user-notifications"
import "./user-menu"

const FiveMinutesInMilliseconds = 1000 * 60 * 5
if (SiteInfo.accessToken !== "") {
    applyNotificationDots(SiteInfo.accessToken)
    checkUserStatusAndUpdateCensoredImagesRights(FiveMinutesInMilliseconds) //every 5 minutes
}
